// original implementation - https://github.com/amitdahan/ngx-filesize/blob/main/packages/ngx-filesize/src/lib/filesize.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { filesize, FilesizeOptions, } from 'filesize';

function transform(value: number, options?: FilesizeOptions): string {
  return filesize<FilesizeOptions>(value, { standard: 'jedec', ...options });
}

@Pipe({ name: 'filesize' })
export class FileSizePipe implements PipeTransform {
  public transform(value: number | number[], options?: FilesizeOptions): string | string[] {
    if (Array.isArray(value)) {
      return value.map(val => transform(val, options));
    }

    return transform(value, options);
  }
}

export { transform as filesize };
